import { createContext, useContext, useMemo, useState } from 'react';

export const LayoutContext = createContext({
  setSummaryShown: () => {},
  summaryShown: true,
  tableShown: false,
  setTableShown: () => {},
});

export const useLayoutContext = () => useContext(LayoutContext);

export const LayoutContextProvider = ({
  children,
  defaultSummaryShown = true,
}) => {
  const [summaryShown, setSummaryShown] = useState(defaultSummaryShown);
  const [tableShown, setTableShown] = useState(false);

  const value = useMemo(
    () => ({
      summaryShown,
      setSummaryShown,
      setTableShown,
      tableShown,
    }),
    [summaryShown, tableShown],
  );

  return (
    <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
  );
};
